export default function getManualAnimation(element, settings){
    const manual = {
        width: settings.width,
        height: settings.height,
        y: settings.top,
        x: settings.left,
        //parseTransform:true,
        clearProps:"transform"
    };
    if( settings.hasOwnProperty("opacity") ){
        manual.opacity = settings.opacity;
    }
    if(settings.hasOwnProperty("fadefirst")){
        manual.fadefirst = true;
    }

    //Change de rotation based on the direction
    if(settings.hasOwnProperty("rotation")){
        manual.rotation = settings.rotation+"deg";

        if( settings.transformOrigin ){
            //"left top | 50% 50%"
            manual.transformOrigin = settings.transformOrigin;
        }
    }

    return manual;
}
